(function () {
  const FALLBACK_THRESHOLD = 25000; // ใช้เมื่ออ่าน data-threshold ไม่ได้
  const POLL_MS = 15000;
  let inFlight = false;
  let debounceTimer = null;

  /** แปลงหน่วยย่อย (cents/fils/sen) เป็นข้อความสกุลเงินของร้าน */
  function formatMoney(subunits) {
    const amount = subunits / 100;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return `${currency} ${Math.ceil(amount)}`;
    }
  }

  /** วาดบาร์ 1 ตัว — ข้ามทันทีถ้าค่าไม่เปลี่ยน (กัน MutationObserver วนลูป) */
  function renderBar(el, total) {
    if (el.dataset.total === String(total)) return;
    el.dataset.total = total;

    const threshold = parseInt(el.dataset.threshold, 10) || FALLBACK_THRESHOLD;

    if (total >= threshold) {
      el.innerHTML = `
        <p class="fsb__msg fsb__msg--success">🎉 You have FREE delivery!</p>
        <div class="fsb__track"><div class="fsb__fill" style="width:100%"></div></div>`;
    } else {
      const remaining = threshold - total;
      let pct = Math.round((total / threshold) * 100);
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;

      el.innerHTML = `
        <p class="fsb__msg">Add <strong>${formatMoney(remaining)}</strong> more for FREE delivery</p>
        <div class="fsb__track"><div class="fsb__fill" style="width:${pct}%"></div></div>`;
    }
  }

  /** ดึงยอดตะกร้าสดแล้ววาดทุกบาร์ในหน้า */
  function refresh() {
    if (inFlight || !document.querySelector('.fsb')) return;
    inFlight = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((cart) => {
        // query ใหม่หลัง fetch เผื่อ drawer เพิ่ง re-render
        document.querySelectorAll('.fsb').forEach((el) => renderBar(el, cart.total_price));
      })
      .catch(() => {})
      .finally(() => { inFlight = false; });
  }

  function debouncedRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 120);
  }

  // Theme cart events
  [
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'on:cart:change',
    'on:line-item:change',
    'on:quick-order-list:update',
    'dispatch:cart-drawer:refresh',
    'on:bfcache:load-restore'
  ].forEach((evt) => document.addEventListener(evt, debouncedRefresh));

  // Fallback: เฝ้าดู cart drawer (ข้าม mutation ที่เกิดจากตัวบาร์เอง)
  const drawer = document.querySelector('cart-drawer, .cart-drawer, #cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver((mutations) => {
      const fromSelf = mutations.every((m) => {
        const node = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        return node && node.closest && node.closest('.fsb');
      });
      if (fromSelf) return;
      debouncedRefresh();
    }).observe(drawer, { childList: true, subtree: true });
  }

  // Initial + poll fallback
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
  setInterval(() => { if (!document.hidden) refresh(); }, POLL_MS);
})();